// Redux.
import { connect } from 'react-redux';


import { MoreHorizOutlined } from '@mui/icons-material';
import { getAnalytics, logEvent } from 'firebase/analytics';

const DownloadWebApp = ({ }) => {
    const analtics = getAnalytics();
    const downloadWebAppStep1Click = () => {
        logEvent(analtics, 'download_web_app_step_1_click');
    }

    return (
        <div>
            <div className='container'>
                <div style={{ padding: '30px 20px' }}>
                    <div className='heading'>
                        Ready in 3 clicks.
                    </div>
                    <div style={{ marginTop: '20px'}}>
                        <img src='/app_screenshots/download_web_app.png' alt='download web app' style={{ width: '100%', borderRadius: '6px' }} />
                    </div>
                    <div style={{ padding: '20px', fontSize: '18px', color: 'var(--app-text-secondary)' }}>
                        <ol>
                            <li style={{ marginBottom: '16px'}}>
                                Open <button onClick={downloadWebAppStep1Click}><a style={{ fontSize: '18px', color: 'var(--app-accent)' }} href='https://podeux.com' target='_blank' rel='noopener noreferrer'>podeux.com</a></button> in your mobile browser.
                            </li>
                            <li style={{ marginBottom: '16px'}}>
                                <span style={{ verticalAlign: 'middle', }}>
                                    Tap the browser menu.
                                </span>
                                <span style={{ padding: '8px 4px', backgroundColor: 'var(--app-surface)', borderRadius: '10px', marginLeft: '10px' }}>
                                    <MoreHorizOutlined style={{ verticalAlign: 'middle' }} />
                                </span>
                                
                            </li>
                            <li>
                                Select <span style={{ fontWeight: '600' }}>Add to Home screen</span> or <span style={{ fontWeight: '600' }}>Install Podeux</span>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(DownloadWebApp);
